module.exports = __webpack_public_path__ + "../resources/img/pv_cal_img3.139de2cd.png";